import { AvailabilityHoursObject } from '../params/redux/calendar';
import { timesData } from '.';

type TimeRange = { start: number; end: number };

export const convertTo24Hour = (time: string): number => {
    const [rawTime, modifier] = time.split(' ');
    // eslint-disable-next-line prefer-const
    let [hours, minutes] = rawTime.split(':').map(Number);

    if (modifier === 'PM' && hours < 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;

    return ((hours * 60) + minutes);
};

export const getAvailableTimeSlots = (blocks: AvailabilityHoursObject[]): TimeRange[] => {
    const blocksList = blocks
        .filter((b) => b.start_time && b.end_time)
        .map((b) => ({
            start: b.start_time ? convertTo24Hour(b.start_time) : 0,
            end: b.end_time ? convertTo24Hour(b.end_time) : 0
        }))
        .sort((a, b) => a.start - b.start);
    const freeSlots: TimeRange[] = [];
    let current = 0;

    for (const range of blocksList) {
        if (range.start > current) {
            freeSlots.push({ start: current, end: range.start });
        }
        current = Math.max(current, range.end);
    }

    if (current < 1440) {
        freeSlots.push({ start: current, end: 1440 });
    }
    return freeSlots;
};

export const getFilteredStartTimeOptions = (hours: AvailabilityHoursObject[], currentHourId: number) => {
    const availableSlots = getAvailableTimeSlots(hours);
     const currentBlock = hours.find((h) => h.id === currentHourId);
    const currentEnd = currentBlock?.end_time
    ? convertTo24Hour(currentBlock.end_time)
    : null;

  return timesData.map((t) => {
    const mins = convertTo24Hour(t);

    const isInFreeSlot = availableSlots.some((slot) => mins >= slot.start && mins < slot.end);

    const isBeforeCurrentEnd = currentEnd === null ? false : mins < currentEnd;

    return {
      label: t,
      value: t,
      disabled: !(isInFreeSlot || isBeforeCurrentEnd)
    };
  });
};

export const getFilteredEndTimeOptions = (time: AvailabilityHoursObject, hours: AvailabilityHoursObject[]) => {
    if (!time?.start_time) {
        return timesData.map((t) => ({ label: t, value: t }));
    }

    const startMins = convertTo24Hour(time?.start_time);

    // Sort the blocks by start time
    const sortedBlocks = [...hours]
        .filter((b) => b.id !== time.id && b.start_time)
        .sort((a, b) => {
            const aStart = a.start_time ? convertTo24Hour(a.start_time) : 0;
            const bStart = b.start_time ? convertTo24Hour(b.start_time) : 0;
            return aStart - bStart;
        });

    // Find the next block after the selected start time
    const nextBlock = sortedBlocks.find((b) => b.start_time && convertTo24Hour(b.start_time) > startMins);

    const endBoundary = nextBlock && nextBlock.start_time ? convertTo24Hour(nextBlock.start_time) : 1440;

    return timesData.map((t) => {
        const mins = convertTo24Hour(t);
        return {
            label: t,
            value: t,
            disabled: mins <= startMins || mins > endBoundary
        };
    });
};